import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TuiButtonModule } from "@taiga-ui/core";
import { KwikUIButtonLiveLocationComponent } from "./button-live-location.component";

@NgModule({
  declarations: [KwikUIButtonLiveLocationComponent],
  imports: [CommonModule, TuiButtonModule],
  exports: [KwikUIButtonLiveLocationComponent]
})
export class KwikUIButtonLiveLocationModule {}
